import React from 'react'
import { connect } from 'react-redux'
import {
  Fade,
} from '@material-ui/core'

import { PHCont } from './styled'
import { StdCard } from 'components'
import { ProcessRow } from './ProcessRow'

const CommentHistory = props => {
  const { grDetail } = props
  return (
    <Fade in={true} timeout={1000}>
      <PHCont>
        <StdCard title="Comment History" style={{ flex: 1 }} accessoriesHeader={props.accessoriesHeader||null}>
          {grDetail &&
            grDetail.goodsServiceReceiptComments.map((item, i) => {
              let files = grDetail.goodsServiceReceiptAttachments.filter(x=>x.commentId===item.id)
              return <ProcessRow data={item} files={files} />
            })}
        </StdCard>
      </PHCont>
    </Fade>
  )
}

const mapStateToProps = state => {
  return {
    grDetail: state.gr.grDetail.data
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CommentHistory)
